const mediumTone = '#3A8DFF'
const strongTone = '#135069'
const lightTone = '#d6ebf3'
const lightFontOverStrong = '#ffffff'
 
export const colorPrimario = '#83b3e6'
export const colorSecundario = '#F5F5F5'
 
export const colorsActionButton = {
	NormalBackground: mediumTone,
	SpecialBackground: strongTone,
	SubMenuBackground: 'white',
	SubMenuFont: 'black',
}
 
export const colorsCommandButton = {
	defaultBackground: strongTone,
	defaultFont: lightFontOverStrong,
}
 
export const colorsBrowse = {
	sectionBorder: mediumTone,
	pairLine: lightTone,
	titleBackground: strongTone,
	titleFont: lightFontOverStrong,
}